import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import Swal from 'sweetalert2';
import { RestClientService } from '../../../../core/service/rest-client.service';
import { AuthService } from '../../../../core/service/auth.service';
import { UtilitiesService } from '../../../../core/service/utilities.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { FileUploadComponent } from '@shared/components/file-upload/file-upload.component';
import { MoneyFormatPipe } from '../../../../shared/pipe/money-format.pipe';

@Component({
  selector: 'app-form-pres-maternite',
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatIconModule,
    FileUploadComponent,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatButtonModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatSlideToggleModule,
    MoneyFormatPipe,
  ],
  templateUrl: './form-pres-maternite.component.html',
  styleUrl: './form-pres-maternite.component.scss',
})
export class FormPresMaterniteComponent {
  @Output() onSendBenefItem = new EventEmitter<any>();
  @Output() onClosePrescriptionMedocModal = new EventEmitter<any>();
  @Output() onGoToTab = new EventEmitter<any>();
  @Output() onPrescriptionSaved = new EventEmitter<void>();
  @Input() matricule: any;
  @Input() refreshTriggerOrdonnance!: boolean;

  itemsElement: any = [];
  garantie_id: any;
  isLoading: boolean | undefined;
  input_value: any;
  input_option = 'MAT';

  user: any = {};
  isConsultationSuccess = false;
  itemConsultation: any = {};
  itemToAdd: any = {};
  itemToSave: any = {};
  itemBeneficiare: any = {};
  fileName1: any;
  currentFile: any;
  selectedConsultation: any = {};
  itemsAffection: any;
  itemsPrescription: any;
  beneficiaireAutOselect: any;
  itemsGarantie: any;
  itemsPraticien: any[] = [];
  itemsActe: any[] = [];
  selectedActeItem: any = null;
  loadingActes = false;
  loadingTarif = false;

  constructor(
    private restClient: RestClientService,
    private router: Router,
    private authService: AuthService,
    private utilities: UtilitiesService,
  ) {
    this.user = this.authService.getCurrentUser();
    this.itemToAdd = {};
    this.itemToSave.mode_prescription = 'produit';
    this.getItemsAffection();
    this.beneficiaireAutOselect = this.authService.getActiveBeneficiaire();
    this.getItemsGarantie();
    this.getItemsPraticien();
  }

  getItemsAffection() {
    this.restClient.post('affection/getByCriteria', { index: 0, size: 1000, data: {} }).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsAffection = res.items;
        } else {
          this.utilities.showSweetNotification(res['status']['message'], 'error');
          this.itemsAffection = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsAffection = [];
      },
    );
  }

  searcheBenef(activeBenefMatricule?: any) {
    this.itemsPrescription = [];
    if (!this.input_value && activeBenefMatricule) {
      this.input_value = activeBenefMatricule;
    }
    this.isLoading = false;
    this.isConsultationSuccess = false;
    this.itemBeneficiare = {};
    this.itemConsultation = {};

    if (!this.input_value) return;

    const request = {
      is_required_dossier: true,
      data: this.input_option == 'CMU'
        ? { numero_cnam: this.input_value }
        : { matricule: this.input_value },
    };

    this.isLoading = true;
    this.restClient.post('beneficiaire/search', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError']) {
          this.itemBeneficiare = res.item;
          this.authService.setActiveBeneficiaire(res.item);
          this.onSendBenefItem.emit(this.itemBeneficiare);
          this.getItemsPrescriptionActive();
        } else {
          this.utilities.showSweetNotification(res['status']['message'], 'error');
          this.itemBeneficiare = {};
        }
      },
      (error) => {
        this.isLoading = false;
        this.utilities.showSweetNotification(error, 'error');
        this.itemBeneficiare = {};
      },
    );
  }

  getItemsPrescriptionActive() {
    if (!this.itemsGarantie || !this.itemsGarantie.length) return;
    const garantie_id = this.itemsGarantie.find((ig: any) => ig.codification == 'CONS')?.id ?? null;
    if (!garantie_id || !this.itemBeneficiare.id) return;

    this.selectedConsultation = {};
    const request = {
      index: 0,
      size: 1000,
      data: {
        garantie_id,
        matricule: this.itemBeneficiare.matricule,
        beneficiaire_id: this.itemBeneficiare.id,
        prestataire_id: this.user.prestataire_id,
        is_factured: 0,
      },
    };

    this.restClient.post('prestationActe/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsPrescription = res.items.filter(
            (it: any) => it.count_mat_non_hospit == 0 && !it.is_expired && !it.is_factured,
          );
          if (this.itemsPrescription?.length) {
            this.itemsPrescription.forEach((ip: any) => (ip.is_active = false));
            if (this.matricule) {
              this.onSelectRow(this.itemsPrescription[0]);
            }
          }
        } else {
          this.utilities.showSweetNotification(res['status']['message'], 'error');
          this.itemsPrescription = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsPrescription = [];
      },
    );
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];
      this.fileName1 = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        const fileBase64 = data.split(',')[1];
        this.currentFile = { fileBase64, fileName, extension, typeDocument: 'custom type' };
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  confirmSaveItem(data: any) {
    Swal.fire({
      title: 'Prescription maternité',
      text: 'Souhaitez-vous poursuivre cette action?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.saveItems();
      }
    });
  }

  saveItems() {
    this.isConsultationSuccess = false;

    if (this.itemsElement && this.itemsElement.length) {
      this.itemsElement.forEach((im: any) => {
        im.affection_id = this.itemToSave.affection_id;
        im.date_presription = this.itemToSave.date_presription;
        im.mode_prescription = this.itemToSave.mode_prescription;
        im.matricule = this.itemBeneficiare.matricule;
        im.beneficiaire_id = this.itemBeneficiare.id;
        im.prestation_acte_id = this.selectedConsultation.id;
        im.dossier_id = this.selectedConsultation.dossier_id;
        im.garantie_id = this.garantie_id;
        im.observation = this.itemToSave.observation;
        im.prestataire_id = this.user.prestataire_id;
        im.praticien_id = this.itemToSave.praticien_id;
        im.is_entente_prealable = true;
        im.is_kine = 1;
      });
    }

    if (this.currentFile && Object.keys(this.currentFile).length) {
      this.itemConsultation.file_data = this.currentFile;
    }

    const request = {
      file_data: this.currentFile && Object.keys(this.currentFile).length ? this.currentFile : '',
      datas: [...this.itemsElement],
    };
    request.datas.forEach((d: any) => { d.prestataire_id = this.user.prestataire_id; });

    this.restClient.post('prescriptionActe/create', request).subscribe(
      (res: any) => {
        if (res && !res['hasError']) {
          this.isConsultationSuccess = true;
          this.utilities.showSweetNotification(res['status']['message'], 'succes');
          this.itemsElement = [];
          this.getItemsPrescriptionActive();
          this.onPrescriptionSaved.emit();
        } else {
          this.isConsultationSuccess = false;
          this.utilities.showSweetNotification(res['status']['message'], 'error');
        }
        this.onClosePrescriptionMedocModal.emit('hide');
      },
      (error) => {
        this.isConsultationSuccess = false;
        this.utilities.showSweetNotification(error, 'error');
      },
    );
  }

  onAddItemToList(): void {
    if (!this.selectedActeItem || !this.selectedActeItem.id) {
      this.utilities.showSweetNotification('Veuillez sélectionner un acte', 'error');
      return;
    }
    if (!this.itemToAdd) this.itemToAdd = { quantite: 1 };
    if (!this.itemToAdd.quantite) this.itemToAdd.quantite = 1;
    if (this.itemsElement.some((ie: any) => ie.acte_id == this.selectedActeItem.id)) {
      this.utilities.showSweetNotification('Cet acte est déjà dans la liste', 'error');
      return;
    }

    const newItem = {
      is_entente_prealable: this.selectedActeItem.is_entente_prealable,
      is_exclu: this.selectedActeItem.is_exclu,
      acte_id: this.selectedActeItem.id,
      acte_libelle: this.selectedActeItem.libelle,
      quantite: 1,
      garantie_id: this.selectedActeItem.garantie_id,
      is_referred: this.selectedActeItem.is_referred,
      montant: 0,
      part_patient: 0,
      part_assurance: 0,
    };

    this.selectedActeItem = null;
    this.itemToAdd = { quantite: 1 };
    this.getTarifActeMaternite(newItem);
  }

  onQuantiteChange(item: any): void {
    if (!item.quantite || item.quantite < 1) item.quantite = 1;
    item.montant = (item.montant_unitaire || 0) * item.quantite;
    item.part_patient = (item.part_patient_unitaire || 0) * item.quantite;
    item.part_assurance = (item.part_assurance_unitaire || 0) * item.quantite;
  }

  getTarifActeMaternite(item: any): void {
    const request = {
      index: 0,
      size: 1000,
      data: {
        acte_id: item.acte_id,
        matricule: this.itemBeneficiare?.matricule,
        prestataire_codification: this.user?.prestataire_codification,
      },
    };
    this.loadingTarif = true;
    this.restClient.post('bareme/getTarifActeOnly', request).subscribe(
      (res: any) => {
        this.loadingTarif = false;
        if (res && !res['hasError'] && res['item']) {
          const t = res.item;
          item.montant_unitaire = t.montant;
          item.part_patient_unitaire = t.part_patient_net;
          item.part_assurance_unitaire = t.part_assurance_net;
          item.montant = t.montant * (item.quantite || 1);
          item.part_patient = t.part_patient_net * (item.quantite || 1);
          item.part_assurance = t.part_assurance_net * (item.quantite || 1);
          item.taux_applicable = t.taux_applicable;
          item.prestation_acte_id = t.prestation_acte_id;
          item.message_explicatif = t.message_explicatif;
          item.message_depassement = t.message_depassement;
          this.itemsElement.unshift(item);
        } else {
          this.utilities.showSweetNotification(res['status']['message'], 'error');
        }
      },
      (error) => {
        this.loadingTarif = false;
        this.utilities.showSweetNotification(error, 'error');
      },
    );
  }

  onSelectRow(item: any): void {
    this.selectedConsultation = { ...item };
    if (item.is_expired) return;
    this.itemsPrescription.forEach((p: any) => (p.is_active = false));
    item.is_active = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['matricule'] && this.matricule) {
      this.input_value = this.matricule;
      this.searcheBenef(this.matricule);
    }
    if (changes['refreshTriggerOrdonnance'] && changes['refreshTriggerOrdonnance'].currentValue) {
      const activeBeneficiaire = this.authService.getActiveBeneficiaire();
      if (activeBeneficiaire.matricule) {
        this.input_value = activeBeneficiaire.matricule;
        this.searcheBenef(activeBeneficiaire.matricule);
      }
    }
  }

  getItemsActe() {
    if (!this.garantie_id) return;
    this.loadingActes = true;
    this.restClient.post('acte/getByCriteria', {
      index: 0,
      size: 1000,
      data: { garantie_id: this.garantie_id },
    }).subscribe(
      (res: any) => {
        this.loadingActes = false;
        this.itemsActe = res?.items ?? [];
      },
      () => { this.loadingActes = false; },
    );
  }

  getItemsPraticien() {
    this.restClient.post('praticien/searchByPrestataire', { index: 0, size: 1000, data: {} }).subscribe(
      (res: any) => {
        if (res && !res['hasError'] && res['items']) {
          this.itemsPraticien = res.items.map((ip: any) => ({
            ...ip,
            full_name: `${ip.nom} ${ip.prenom} (${ip.specialite_libelle})`,
          }));
        } else {
          this.itemsPraticien = [];
        }
      },
      () => { this.itemsPraticien = []; },
    );
  }

  getItemsGarantie() {
    this.restClient.post('garantie/getByCriteria', { index: 0, size: 1000, data: {} }).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsGarantie = res.items;
          this.garantie_id = this.itemsGarantie.find((ig: any) => ig.codification == 'MAT')?.id ?? null;
          this.getItemsActe();
          this.getItemsPrescriptionActive();
        } else {
          this.utilities.showSweetNotification(res['status']['message'], 'error');
          this.itemsGarantie = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsGarantie = [];
      },
    );
  }
}
